import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Typography from '@material-ui/core/Typography'
import CollapsibleSectionStyles from '../styles/components/collapsible-section'

/**
 * Wrapper to ExpansionPanel from material UI
 *
 * @class CollapsibleSection
 * @extends {Component}
 */
class CollapsibleSection extends React.Component {
  constructor (props) {
    super(props)
    // NOTE: we will use either the state or props. We will use the state when there is no 'onExpanded' method to call
    // so we can expand and collapse the item when its clicked
    this.state = {
      expanded: this.props.expanded
    }
  }

  handleChange = panelKey => (event, expanded) => {
    if (this.props.onExpanded) {
      this.props.onExpanded(panelKey, expanded)
    } else {
      this.setState({ expanded })
    }
  }

  render () {
    // render all the items in the collection
    let { classes } = this.props

    return (
      <div className={classes.root}>
        <ExpansionPanel
          className={this.props.showMuiBorder ? classes.panel : classes.panelNoMargins}
          expanded={this.props.onExpanded ? this.props.expanded : this.state.expanded}
          onChange={this.handleChange(this.props.id)}>
          <ExpansionPanelSummary
            className={this.props.showMuiBorder ? classes.panelSummary : classes.panelSummaryNoMargins}
            classes={{ content: classes.panelSummaryContent }}
            expandIcon={<ExpandMoreIcon />}
          >
            <div className={classes.headingContainer}>
              <Typography className={classes.heading}>{this.props.heading}</Typography>
              {this.props.secondaryHeading
                ? <Typography className={classes.secondaryHeading}>{this.props.secondaryHeading}</Typography>
                : null}
            </div>
            { this.props.accessory || null }
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={this.props.showMuiBorder ? classes.details : classes.detailsNoMargins}>
            {this.props.children}
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </div>
    )
  }
}

CollapsibleSection.defaultProps = {
  expanded: false,
  showMuiBorder: true
}

CollapsibleSection.propTypes = {
  id: PropTypes.string.isRequired,
  heading: PropTypes.any.isRequired,
  secondaryHeading: PropTypes.string,
  expanded: PropTypes.bool.isRequired,
  onExpanded: PropTypes.func,
  showMuiBorder: PropTypes.bool
}

const styles = theme => ({
  ...CollapsibleSectionStyles(theme)
})

export default withStyles(styles)(CollapsibleSection)



// WEBPACK FOOTER //
// ./src/controls/CollapsibleSection.js